import { create } from 'zustand';
import { Campaign } from "../types/campaign";
import { Template } from '../types/template';
import { AdminAllPaymentHistory } from "../types/adminPaymentHistory";
import { PaymentHistory } from '../types/paymentHistory';

// Campaigns Data

interface CampaignsDataState {
    activeCampaigns: Campaign[];
    setActiveCampaigns: (v: Campaign[]) => void;
    pendingApprovalCampaigns: Campaign[];
    setPendingApprovalCampaigns: (v: Campaign[]) => void;
    reset: () => void;
};

export const useCampaignsDataStore = create<CampaignsDataState>((set) => ({
    activeCampaigns: [],
    setActiveCampaigns: (v: Campaign[]) => set(({ activeCampaigns: v })),
    pendingApprovalCampaigns: [],
    setPendingApprovalCampaigns: (v: Campaign[]) => set(({ pendingApprovalCampaigns: v })),
    reset: () => set({
        activeCampaigns: [],
        pendingApprovalCampaigns: []
    }),
}));

// Templates Data

interface TemplatesDataState {
    templates: Template[];
    setTemplates: (v: Template[]) => void;
    reset: () => void;
};

export const useTemplatesDataStore = create<TemplatesDataState>((set) => ({
    templates: [],
    setTemplates: (v: Template[]) => set(({ templates: v })),
    reset: () => set({ templates: [] }),
}));

// Payment Data

interface PaymentState {
    adminPaymentHistory: AdminAllPaymentHistory[];
    setAdminPaymentHistory: (v: AdminAllPaymentHistory[]) => void;
    succeededPaymentHistory: PaymentHistory | null;
    setSuccededPaymentHistory: (v: PaymentHistory | null) => void;
    failedPaymentHistory: PaymentHistory | null;
    setFailedPaymentHistory: (v: PaymentHistory | null) => void;
    reset: () => void;
};

export const usePaymentStore = create<PaymentState>((set) => ({
    adminPaymentHistory: [],
    setAdminPaymentHistory: (v: AdminAllPaymentHistory[]) => set(({ adminPaymentHistory: v })),
    succeededPaymentHistory: null,
    setSuccededPaymentHistory: (v: PaymentHistory | null) => set(({ succeededPaymentHistory: v })),
    failedPaymentHistory: null,
    setFailedPaymentHistory: (v: PaymentHistory | null) => set(({ failedPaymentHistory: v })),
    reset: () => set({
        adminPaymentHistory: [],
        succeededPaymentHistory: null,
        failedPaymentHistory: null,
    }),
}));

// Reset Function

export function resetStores() {
    useCampaignsDataStore.getState().reset();
    useTemplatesDataStore.getState().reset();
    usePaymentStore.getState().reset();
}
